import { StyledButtonIconCircle } from './Style'
import { Loader } from '../Loader'

export const ButtonIconCircle = ({ searching, ...props }) => {
  return (
    <StyledButtonIconCircle {...props}>{searching ? <Loader color='white' /> : props.children}</StyledButtonIconCircle>
  )
}
